import { gsap } from "gsap";
import { isMobile } from '../utlis/is-mobile';

export default class Tile {
  constructor(element) {
    this.el = element;
    this.imgWrap2 = this.el.querySelector('[img-wrap-2]');
    this.rect = null;
    this.mouseOver = false;

    this.init();
  }

  init() {
    if (isMobile) return;

    // Bind events
    this.el.addEventListener("mousemove", this.handleMouseMove.bind(this));
    this.el.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
    window.addEventListener("resize", this.updateRect.bind(this));

    // Initialize element's rect
    this.updateRect();
  }

  updateRect() {
    this.rect = this.el.getBoundingClientRect();
  }

  handleMouseMove(event) {
    if (!this.mouseOver) {
      this.mouseOver = true;
      this.el.classList.add("is-mouse-over");
    }

    const { clientX, clientY } = event;
    const centerX = this.rect.left + this.rect.width / 2;
    const centerY = this.rect.top + this.rect.height / 2;

    const deltaX = clientX - centerX;
    const deltaY = clientY - centerY;

    const rotateX = (deltaY / this.rect.height) * 12; // Adjust tilt sensitivity
    const rotateY = -(deltaX / this.rect.width) * 12;
    const translateX = (deltaX / this.rect.width) * 6;

    // Animate transforms with GSAP
    gsap.to(this.imgWrap2, {
      duration: 0.3,
      ease: "power3.out",
      rotateX: rotateX, // Apply rotation
      rotateY: rotateY,
      x: translateX,    // Apply translation
      y: 0,
      z: 0
    });
  }

  handleMouseLeave() {
    this.mouseOver = false;
    this.el.classList.remove("is-mouse-over");

    // Reset transforms
    gsap.to(this.imgWrap2, {
      duration: 0.5,
      ease: "power2.out",
      rotateX: 0, // Reset rotation
      rotateY: 0,
      x: 0,       // Reset translation
      y: 0,
      z: 0,       // Reset z-index for perspective if needed
    });
  }
}

